import React, { useState, useEffect, useContext } from "react";
import "./Register.css";
import "./Login.css";
import sahabatKakaoImg from "../assets/Sahabatkakao.png";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import AlertCard from "../components/AlertCard";

export default function Login() {
  const [showLoginPass, setShowLoginPass] = useState(false);
  const [showNewPass, setShowNewPass] = useState(false);
  const [showConfirmPass, setShowConfirmPass] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [alert, setAlert] = useState({ visible: false, message: "", type: "info" });
  const [showForgotForm, setShowForgotForm] = useState(false);
  const [updatingPassword, setUpdatingPassword] = useState(false);

  const [loginData, setLoginData] = useState({
    identifier: "",
    password: ""
  });
  const [forgotData, setForgotData] = useState({
    identifier: "",
    newPassword: "",
    confirmPassword: ""
  });

  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    const savedIdentifier = localStorage.getItem("loginIdentifier");
    const savedPassword = localStorage.getItem("loginPassword");
    if (savedIdentifier && savedPassword) {
      setLoginData({ identifier: savedIdentifier, password: savedPassword });
      setRememberMe(true);
    }
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      
      const response = await fetch(`${apiUrl}/users/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          identifier: loginData.identifier,
          password: loginData.password
        })
      });

      const data = await response.json();

      if (data.success) {
        setAlert({ visible: true, message: "Login berhasil!", type: "success" });
        login(data.user, data.token);

        if (rememberMe) {
          localStorage.setItem("loginIdentifier", loginData.identifier);
          localStorage.setItem("loginPassword", loginData.password);
        } else {
          localStorage.removeItem("loginIdentifier");
          localStorage.removeItem("loginPassword");
        }

        localStorage.setItem("userId", data.user.id); // simpan user ID untuk halaman profil
        navigate("/dashboard");
      } else {
        setAlert({ visible: true, message: data.message || "Email/No HP atau password salah", type: "error" });
      }
    } catch (error) {
      console.error("Login error:", error);
      setAlert({ visible: true, message: "Terjadi kesalahan saat login.", type: "error" });
    }
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    if (!forgotData.identifier || !forgotData.newPassword || !forgotData.confirmPassword) {
      setAlert({ visible: true, message: "Semua field ganti password wajib diisi.", type: "error" });
      return;
    }

    if (forgotData.newPassword.length < 6) {
      setAlert({ visible: true, message: "Password baru minimal 6 karakter.", type: "error" });
      return;
    }

    if (forgotData.newPassword !== forgotData.confirmPassword) {
      setAlert({ visible: true, message: "Konfirmasi password tidak cocok.", type: "error" });
      return;
    }

    try {
      setUpdatingPassword(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await fetch(`${apiUrl}/users/forgot-password`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          identifier: forgotData.identifier,
          new_password: forgotData.newPassword
        })
      });

      const data = await response.json();
      if (data.success) {
        setAlert({ visible: true, message: "Password berhasil diubah. Silakan login.", type: "success" });
        setLoginData((prev) => ({ ...prev, identifier: forgotData.identifier, password: "" }));
        setForgotData({ identifier: "", newPassword: "", confirmPassword: "" });
        setShowForgotForm(false);
      } else {
        setAlert({ visible: true, message: data.message || "Gagal mengubah password.", type: "error" });
      }
    } catch (error) {
      console.error("Forgot password error:", error);
      setAlert({ visible: true, message: "Terjadi kesalahan saat mengganti password.", type: "error" });
    } finally {
      setUpdatingPassword(false);
    }
  };

  return (
    <div
      className="auth-container login-page"
      style={{ backgroundImage: `url(${sahabatKakaoImg})` }}
    >
      <div className="auth-card login-card">
        <h2>Masuk ke Akun Sahabat Kakao</h2>
        <form className="auth-form" onSubmit={handleLogin}>
          <input
            type="text"
            placeholder="Email / No Handphone"
            value={loginData.identifier}
            onChange={(e) => setLoginData({ ...loginData, identifier: e.target.value })}
            required
          />
          <div className="password-field">
            <input
              type={showLoginPass ? "text" : "password"}
              placeholder="Password"
              value={loginData.password}
              onChange={(e) => setLoginData({ ...loginData, password: e.target.value })}
              required
            />
            <span onClick={() => setShowLoginPass(!showLoginPass)}>
              {showLoginPass ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>
          <div className="login-meta">
            <div className="checkbox">
              <label>
                <input
                  type="checkbox"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                />
                Ingat saya
              </label>
            </div>
            <button
              type="button"
              className="forgot-toggle"
              onClick={() => setShowForgotForm((prev) => !prev)}
            >
              {showForgotForm ? "Kembali ke login" : "Lupa password?"}
            </button>
          </div>
          <button type="submit" className="submit-btn">Login</button>
        </form>

        {showForgotForm && (
          <form className="auth-form forgot-form" onSubmit={handleForgotPassword}>
            <h3>Ganti Password</h3>
            <input
              type="text"
              placeholder="Email / No Handphone"
              value={forgotData.identifier}
              onChange={(e) => setForgotData({ ...forgotData, identifier: e.target.value })}
              required
            />

            <div className="password-field">
              <input
                type={showNewPass ? "text" : "password"}
                placeholder="Password Baru"
                value={forgotData.newPassword}
                onChange={(e) => setForgotData({ ...forgotData, newPassword: e.target.value })}
                required
              />
              <span onClick={() => setShowNewPass((prev) => !prev)}>
                {showNewPass ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>

            <div className="password-field">
              <input
                type={showConfirmPass ? "text" : "password"}
                placeholder="Konfirmasi Password Baru"
                value={forgotData.confirmPassword}
                onChange={(e) => setForgotData({ ...forgotData, confirmPassword: e.target.value })}
                required
              />
              <span onClick={() => setShowConfirmPass((prev) => !prev)}>
                {showConfirmPass ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>

            <button type="submit" className="submit-btn" disabled={updatingPassword}>
              {updatingPassword ? "Memproses..." : "Simpan Password Baru"}
            </button>
          </form>
        )}
      </div>

      {alert.visible && (
        <AlertCard
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert((prev) => ({ ...prev, visible: false }))}
        />
      )}
    </div>
  );
}
